import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Magnetic } from "../../../styles";
export const StyledDivHeading = styled('div', {
    shouldForwardProp: prop => prop !== 'textColor' && prop !== 'headingFontSize'
})((props) => `
    color: ${props.textColor};
    font-size: ${props.headingFontSize || Magnetic.fontSize14};
    font-weight: ${Magnetic.fontWeightSemibold};
  `);
export const StyledDivSubHeading = styled('div', {
    shouldForwardProp: prop => prop !== 'textColor' && prop !== 'subHeadingFontSize'
})((props) => `
    color: ${props.textColor};
    font-size: ${props.subHeadingFontSize || Magnetic.fontSize10};
  `);
export const StyledDivDistance = styled('div', {
    shouldForwardProp: prop => prop !== 'textColor' && prop !== 'distanceFontSize'
})((props) => `
    color: ${props.textColor};
    font-size: ${props.distanceFontSize || Magnetic.fontSize10};
    font-weight: ${Magnetic.fontWeightHeavy};
    margin-top: ${Magnetic.spacer10};
  `);
export const StyledGridContainer = styled(Grid, {
    shouldForwardProp: prop => prop !== 'isItemSelected' &&
        prop !== 'selectedBackgroundColor' &&
        prop !== 'backgroundColor' &&
        prop !== 'mouseHoverColor'
})((props) => `
    background-color: ${props.isItemSelected
    ? props.selectedBackgroundColor || Magnetic.colorBrand60
    : props.backgroundColor || Magnetic.colorWhite};
    width: 100%;
    display: flex;
    flex-direction: row;
    border-radius: ${Magnetic.baseBorderRadius};
    padding: ${Magnetic.spacer04};
    cursor: ${Magnetic.actionableColor};
    :hover {
      background-color: ${!props.isItemSelected &&
    (props.mouseHoverColor || Magnetic.colorBrand20)};
      color: ${Magnetic.colorNeutral80};
    }
  `);
const StyledDivContainer = styled('div')(`
  display: inline-flex;
  flex-direction: column;
`);
export const StyledInnerDivContainer = styled('div')(`
  margin-right: ${Magnetic.spacer06};
`);
export const StyledMainContainer = styled('div')(`
  display: flex;
`);
export const StyledDivContentContainer = styled(StyledDivContainer)(`
  width: 80%;
  overflow-wrap: break-word;
`);
export const StyledDivDistanceContainer = styled(StyledDivContainer)(`
  width: 20%;
  text-align: end;
`);
export const HighLightTextContainer = styled('div', {
    shouldForwardProp: prop => prop !== 'highLightBackgroundColor' && prop !== 'subHeadingFontSize'
})((props) => `
    color: ${Magnetic.colorBlack};
    font-size: ${props.subHeadingFontSize || Magnetic.fontSize10};
    padding: ${Magnetic.spacer04};
    background-color: ${props.highLightBackgroundColor};
    border: ${Magnetic.baseBorderWidth} ${Magnetic.baseBorderStyle} ${Magnetic.colorBlack};
  `);
//# sourceMappingURL=WhiteLabelMobileResourceTile.style.js.map